function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 37,
  cy: 37,
  r: 35.5,
  fill: "#000",
  fillOpacity: .737,
  fillRule: "nonzero",
  stroke: "#FFF",
  strokeWidth: 3
}), React.createElement("path", {
  fill: "#FFF",
  d: "M29.53 21.957l22.09 13.82a1 1 0 0 1-.014 1.703L29.516 50.8A1 1 0 0 1 28 49.944V22.805a1 1 0 0 1 1.53-.848z"
}));

const SvgComponent = props => React.createElement("svg", _extends({
  width: 74,
  height: 74,
  viewBox: "0 0 74 74"
}, props), _ref);

export default __webpack_public_path__ + "static/media/play-btn.4e7953ba.svg";
export { SvgComponent as ReactComponent };